<template>

    <div v-cloak>
        <div class="row">

            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'home'}">{{$t("inicio")}}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'configuracion'}">{{$t("configuracion")}}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">{{$t("categoriaClientes")}}</li>
                    </ol>
                </nav>
            </div>

            <div class="col-md-12">
                <div class="card">
                    <div class="row">
                        <div class="col-md-4">
                            <div class="form-group">
                                <label>{{$t("companya")}}</label>

                                <el-select class="select-default"
                                           size="large"
                                           v-model="idCompany"
                                           filterable
                                           :placeholder="$t('seleccionaCompania')"
                                           @change="cambioNegocio()">
                                    <el-option v-for="c in listCompany"
                                               class="select-primary"
                                               :value="c.id"
                                               :label="c.name"
                                               :key="c.name">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>

                    </div>
                </div>
            </div>


            <div class="col-md-12" v-if="respuesta">
                <div class="card">

                    <div class="row">
                        <div class="col-md-8">
                            <div class="form-group">
                                <router-link
                                        :to="{name:'categoria-cliente', params:{'idCompany':this.idCompany}}">
                                    <button class="btn btn-primary"><i class="fa fa-plus-square"></i>
                                        {{$t('agregarCategoriaDeClientes')}}
                                    </button>
                                </router-link>
                            </div>
                        </div>

                        <div class="col-md-4 text-right">
                            <div class="input-group">
                                <input type="text" class="form-control" v-bind:placeholder="$t('buscar')"
                                       v-model="searchQuery"
                                       @keyup.enter.prevent="searchCasas">
                                <div class="input-group-append">
                                    <button class="btn btn-secondary" type="button" @click="searchCasas"><i
                                            class="fa fa-search"></i>
                                    </button>
                                    <button class="btn btn-secondary" type="button" @click="removeSearch"><i
                                            class="fa fa-times"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row" v-if="isSearch">
                        <div class="col-md-12">
                            <p>
                                <small>{{showResult}}</small>
                            </p>
                        </div>
                    </div>

                    <div class="table-responsive" v-if="listCategoriasClientes.length > 0">
                        <table class="table table-bordered table-striped">
                            <thead class="thead-dark">
                            <tr>
                                <th>{{$t("nombre")}}</th>
                                <th>{{$t("categoriaPadre")}}</th>
                                <th>{{$t("acciones")}}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="c in listCategoriasClientes">
                                <td>
                                    <div>{{c.name}} {{c.surName}}

                                        <span style="color: red" v-if="c.baja">
                                            [{{$t("BAJA")}}]
                                        </span>

                                    </div>
                                </td>
                                <td>
                                    <div>{{c.nombreParent}}</div>
                                </td>
                                <td style="width: 70px; text-align: center">
                                    <router-link
                                            :to="{name:'categoria-cliente', params:{'idCategoriaCliente':c.id,'idCompany':idCompany, 'pag':pag}}">
                                        <a class="btn btn-danger btn-link btn-xs">
                                            <i v-tooltip.top-center="$i18n.t('editar')" class="fas fa-pencil-alt"
                                               style="color: orange"></i>
                                        </a>
                                    </router-link>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="alert alert-danger" role="alert" v-else>
                        {{$t("noHay")}} <strong>{{$t("clientes")}}</strong> {{$t("enEsteNegocio")}}
                    </div>

                    <div class="row" v-if="!isSearch && totalPags > 1">
                        <div class="col-md-12">
                            <nav>
                                <ul class="pagination flex-wrap">
                                    <li class="page-item" :class="{'disabled':pag == 1}">
                                        <router-link class="page-link" :to="{name: 'categorias-clientes', params: {pag: pag-1}}"
                                                     v-if="pag != 1">&laquo;
                                        </router-link>
                                        <span v-else class="page-link"><span aria-hidden="true">&laquo;</span></span>
                                    </li>
                                    <li class="page-item" v-for="n in totalPags" :class="{active : n == pag}">
                                        <router-link class="page-link" :to="{name: 'categorias-clientes', params: {pag:n}}">{{n}}
                                        </router-link>
                                    </li>
                                    <li class="page-item" :class="{'disabled':pag == totalPags}">
                                        <router-link class="page-link" :to="{name: 'categorias-clientes', params: {pag: nextPag}}"
                                                     v-if="pag != totalPags">
                                            &raquo;
                                        </router-link>
                                        <span v-else class="page-link"><span aria-hidden="true">&raquo;</span></span>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import {DatePicker, Select, Option, Dropdown, DropdownItem, DropdownMenu, Button} from 'element-ui'
    import {Loading} from 'element-ui';
    import swal from 'sweetalert2'


    export default {
        name: "CategoriasClientes",

        created() {
//            this.loading = Loading.service({text: 'Cargando...'});
            this.$store.dispatch("setNameRoute", this.$i18n.t("clientes"));
            this.getCompanies();

        },
        components: {
            [DatePicker.name]: DatePicker,
            [Select.name]: Select,
            [Dropdown.name]: Dropdown,
            [DropdownItem.name]: DropdownItem,
            [DropdownMenu.name]: DropdownMenu,
            [Button.name]: Button,
            [Option.name]: Option
        },
        data() {
            return {
                loading: false,
                searchQuery: this.$route.params.query,
                isSearch: false,
                pag: this.$route.params.pag,
                totalPags: 0,

                respuesta: true,

                //CLIENTES
                idCompany: this.$route.params.idCompany,
                listCompany: [],
                listCategoriasClientes: ["-"]
            }
        },
        watch: {
            '$route'(to, from) {
                if (to.params.pag) {
                    this.pag = to.params.pag;
                    this.getCategoryClientes();
                } else if (to.params.query) {
                    this.query = to.params.query;
                    this.getCategoryClientes();
                }
            }
        },
        computed: {
            showResult() {
                if (this.listCategoriasClientes.length == 0) {
                    return this.$t('noEncontramosResultadosPara') + this.searchQuery;
                } else {
                    const result = this.listCategoriasClientes.length == 1 ? this.$t('resultado') : this.$t('resultados');
                    return this.$t('mostrando')+" " + this.listCategoriasClientes.length + " " + result;
                }
            },
            nextPag() {
                let nextPag = parseInt(this.pag) + 1;
                return nextPag;
            },
            urlExportPDF() {

                return "../api/public/index.php/clients/exportListClients/PDF?idCompany=" + this.idCompany + "&jwt=" + this.$store.getters.jwt

            },
            urlExportExcel() {

                /*  return "../api/public/index.php/suppliers/exportGastosSupplier/Excel?idBusiness=" + this.idBusiness + "&procedencia=" + this.procedencia + "&idSupplier=" + this.idSupplier + "&datefrom=" + moment(this.datefrom).unix() + "&dateto=" + moment(this.dateto).unix() + "&jwt=" + this.$store.getters.jwt
                 */
                return "../api/public/index.php/clients/exportListClients/Excel?idCompany=" + this.idCompany + "&jwt=" + this.$store.getters.jwt
            },
        },
        methods: {
            getCompanies() {
                var config = {
                    params: {
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "general/getCompaniesByUser", config)
                    .then(function (response) {

                        if (!vm.idCompany) {
                            vm.idCompany = response.data.result[0].id;
                        }
                        vm.listCompany = response.data.result;

                        vm.getCategoryClientes()

                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            cambioNegocio() {

                this.pag = 1;
                this.totalPags = 0;

                this.getCategoryClientes();


            },
            getCategoryClientes() {

                const controller = this.searchQuery ? 'searchCategoriesClientsByCompany/' + this.searchQuery : 'getCategoriesClientsByCompany';
                var config = {
                    params: {
                        pag: this.pag,
                        idCompany: this.idCompany,
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "clients/" + controller, config)
                    .then(function (response) {
                        if (response.data.response) {
                            vm.listCategoriasClientes = response.data.result.categoryClients;
                            vm.pag = response.data.result.pag;
                            vm.totalPags = response.data.result.totalPags;
                            vm.respuesta = true;

                        }
                        else {
                            vm.loadingGeneral.close();
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });

                            vm.respuesta = false;
                        }

//                        vm.loading.close();
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            searchCasas() {
                if (this.searchQuery !== undefined && this.searchQuery !== "") {
                    this.$router.push({name: 'search-categorias-clientes', params: {query: this.searchQuery}});
                    this.isSearch = true;
                }
            },
            removeSearch() {
                if (this.searchQuery && this.searchQuery !== "") {
                    this.searchQuery = "";
                    this.isSearch = false;
                    this.$router.push({name: 'categorias-clientes'});
                    this.getCategoryClientes()
                }
            }
        }
    }
</script>

<style scoped>



    [v-cloak] {
        display: none;
    }

    tbody tr:hover {
        background-color: rgba(0, 153, 130, 0.2);
    }

    tbody td {
        padding: 0 !important;
    }

    td div {
        padding: 12px 8px;
        color: #333;
    }

    .buttonsSearch:hover {
        cursor: pointer;
        background-color: rgba(0, 153, 130, 0.1);
    }

    .card {
        padding: 20px;
    }

    .input-group button {
        height: 40px;
    }

</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Configuracion/CategoriasClientes/CategoriasClientes.vue